const mailBoxType = {
  FETCH_PAYER_LIST: 'FETCH_PAYER_LIST',
  UPDATE_EMAIL_CONFIGURATION: 'UPDATE_EMAIL_CONFIGURATION',
  UPDATE_RPA_EMAIL_CONFIGURATION: 'UPDATE_RPA_EMAIL_CONFIGURATION',
  SAVE_MAILBOX_EMAIL_CONFIG: 'SAVE_MAILBOX_EMAIL_CONFIG',
  GET_AUTH_REDIRECT_URL: 'GET_AUTH_REDIRECT_URL',
  DELAY_MAILBOX_CONFIGURATION: 'DELAY_MAILBOX_CONFIGURATION',
  ENABLE_SWITCH_CHECK: 'ENABLE_SWITCH_CHECK',
  SHOW_EMAIL_VERIFY_MODAL: 'SHOW_EMAIL_VERIFY_MODAL',
  SET_HOSPITAL_SECONDARY_MAIL_ID: 'SET_HOSPITAL_SECONDARY_MAIL_ID',
  FETCH_LATEST_HOSPITAL_MAIL_DATA: 'FETCH_LATEST_HOSPITAL_MAIL_DATA',
  FETCH_PAYER_CONFIGURATION: 'FETCH_PAYER_CONFIGURATION',
  SET_PAYER_CONFIGURATION: 'SET_PAYER_CONFIGURATION',
  SAVE_PAYER_ENABLE_TOGGLE_CONFIGURATION: 'SAVE_PAYER_ENABLE_TOGGLE_CONFIGURATION',
  SAVE_PAYER_EMAIL_CONFIGURATION: 'SAVE_PAYER_EMAIL_CONFIGURATION',
  VERIFY_AND_SAVE_PORTAL_CREDENTIALS: 'VERIFY_AND_SAVE_PORTAL_CREDENTIALS',
  SAVE_DEPARTMENT_EMAIL_CONFIGURATION: 'SAVE_DEPARTMENT_EMAIL_CONFIGURATION',
  SAVE_HOSPITAL_PRIMARY_ID: 'SAVE_PRIMARY_ID',
  SAVE_HOSPITAL_SECONDARY_ID: 'SAVE_SECONDARY_ID',
  FETCH_HOSPITAL_CONFIGURATION: 'FETCH_HOSPITAL_CONFIGURATION',
  UPDATE_HOSPITAL_EMAIL_CONFIGURATION: 'UPDATE_HOSPITAL_EMAIL_CONFIGURATION',
  SELECT_ENABLED_PAYER: 'SELECT_ENABLED_PAYER',
  SELECT_CENTER_ID: 'SELECT_CENTER_ID',
};
export default mailBoxType;
